import { TableCell, TableRow } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { TooltippedTruncatedText } from '~/components/TooltippedTruncatedText';

import { useSxStyles } from './useStyles';

export interface TeamMemberCompensationProps {}

export const TableHeader: React.FC<TeamMemberCompensationProps> = () => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();
  return (
    <TableRow>
      <TableCell sx={{ ...sxStyles.cell, ...sxStyles.avatarCell }} />
      <TableCell sx={sxStyles.cell} />
      <TableCell align="right" sx={sxStyles.cell} data-cy="salary-frequency">
        <TooltippedTruncatedText>
          {t<string>('frequency')}
        </TooltippedTruncatedText>
      </TableCell>
      <TableCell align="right" sx={sxStyles.cell} data-cy="base-salary">
        <TooltippedTruncatedText>
          {t<string>('baseSalary')}
        </TooltippedTruncatedText>
      </TableCell>
    </TableRow>
  );
};
